import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-fullservicecustomer-grid',
  templateUrl: './FullServiceCustomerGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => FullServiceCustomerGridComponent)}]
})
export class FullServiceCustomerGridComponent extends BaseGridComponent {
    lineItems: ent.FullServiceCustomer[] = [];


    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    @Output() public lineItemEditClicked: EventEmitter<ent.FullServiceCustomer> = new EventEmitter();
    
    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

        
   

    ngOnInit(): void {

    }

    getGlobalFilterFields(): string[]{
        var fields = ['CustomerNumber', 'Name', 'SalesOffice.Name', 'FullServiceCustomerType.Name'];
        return fields;
    }

    onEditClick(event: any, lineItem: ent.FullServiceCustomer){
        this.lineItemEditClicked.emit(lineItem);
    }

    checkAllChange(event: any){
        for (var item of this.lineItems){
            item.Included = event;
        }
    }

    
}